import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  Typography,
} from '@mui/material';
import { BaseFieldProps } from 'components/organisms/forms/form-builder/types';
import { noop } from 'lodash';
import React, { FC, useState } from 'react';

import { InputField } from './InputField';

export const PatientDescriptionField: FC<BaseFieldProps<string>> = ({
  disabled = false,
  fieldKey,
  initValue = '',
  label = 'Description',
  onChange = noop,
  xs = 12,
}) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <Grid item xs={xs}>
      <Accordion
        disableGutters
        expanded={expanded}
        onChange={(_, nextExpanded) => setExpanded(nextExpanded)}
        data-testid={`${fieldKey}-section`}
        slotProps={{ transition: { unmountOnExit: false } }}
      >
        <AccordionSummary
          aria-controls={`${fieldKey}-content`}
          expandIcon={<ExpandMoreIcon />}
          id={`${fieldKey}-header`}
          data-testid={`${fieldKey}-toggle`}
        >
          <Typography>{label}</Typography>
        </AccordionSummary>
        <AccordionDetails id={`${fieldKey}-content`}>
          <Grid container>
            <InputField
              disabled={disabled}
              fieldKey={fieldKey}
              initValue={initValue}
              label="Patient-specific description"
              multiline
              onChange={onChange}
              restoreValueOnEmpty={false}
              rows={5}
              type="text"
            />
          </Grid>
        </AccordionDetails>
      </Accordion>
    </Grid>
  );
};
